module.exports = __webpack_public_path__ + "static/media/nancylogo.b923957e.jpg";